<div class="row">
    <div class="col-md-12">
        <app-location-dropdowns
            (loadTestSessionsByTestCentre)=getTestSessionsByTestCentre($event)
            (loadTestSessionsForRegistration)=getTestSessionsForRegistration($event)
            (filterSittings)=filterSittingsByCity($event)
            (reloadSittings)=updateSittings($event)
            [cities]="cities"
            [testTypeId]="testTypeId"
            [testPurposeId]="testPurposeId"
        ></app-location-dropdowns>
    </div>
</div>

<div class="row">
    <div class="col-md-8 col-lg-6">
        <app-sitting-list
            [sittings]="publicSittings"
            [isPrivate]="false"
            [webDelivery]="webDelivery"
            [testTypeId]="testTypeId"
            (selectSitting)=finalizeSelectedSitting($event)
        >
        </app-sitting-list>
    </div>
</div>

<div
    class="row"
    *ngIf="showAlert && publicSittings?.length < 1"
>
    <div class="col-md-8 col-lg-6">
        <div class="alert alert-danger">
            <p *ngIf="brandId=== BrandEnum.CAEL">No test sittings available at this time.</p>
            <p *ngIf="brandId=== BrandEnum.CELPIP"> At this time, there are no test sittings available at this location.For more information, please contact our office by email at info@celpip.ca or toll-free at 1-800-958-5186.</p>
        </div>
    </div>
</div>
